export const columnOptions = [
	// {
	//   label: 'ID',
	//   props: 'username'
	// },
	// {
	//   label: 'commons.nick_name',
	//   props: 'nickName'
	// },
	{
		label: 'ID',
		props: 'userId'
	},
	{
		label: '姓名',
		props: 'name'
	},
	{
		label: '账号',
		props: 'phone'
	},
	{
		label: '所属组织',
		props: 'organization'
	},
	{
		label: '操作员角色',
		props: 'roleName'
	},
	// {
	//   label: 'user.source',
	//   props: 'from'
	// },
	{
		label: 'commons.email',
		props: 'email'
	},
	{
		label: 'commons.organization',
		props: 'dept'
	},
	{
		label: 'commons.role',
		props: 'roles'
	},
	{
		label: 'commons.status',
		props: 'status'
	},
	{
		label: 'commons.create_time',
		props: 'createTime'
	}
]